import styled from 'styled-components';

const MediaContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 20px;
  padding: 20px;

  @media (max-width: ${(props) =>
      props.theme.devices.isTablet ? '0px' : '845px'}) {
    gap: 16px;
    padding: 16px;
  }

  .addArticle {
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-size: 14px;
    font-weight: 600;
    line-height: 0.79;
    text-align: center;
    color: ${(props) => props.theme.colors['white']};
    flex-direction: row-reverse;
    min-width: 210px;
    text-transform: none;
    margin-left: auto;
    height: 86px;

    span {
      margin-left: 10px;
    }

    .icon {
      font-size: 3em;
      margin-right: 40px;
    }
  }

  .kpiValueText {
    text-transform: none;
    font-size: 10px;
    margin-top: 1px;
  }

  .kpi {
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-size: 14px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.71;
    letter-spacing: normal;
  }

  .filters,
  .navigation {
    margin-top: 20px;
  }

  .navigation {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .navigation-pager {
    display: flex;
    height: 40px;
    margin-right: 20px;
    align-items: center;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-size: 16px;
  }

  .navigation-current {
    color: ${(props) => props.theme.colors['terra-cotta']};
    font-weight: bold;
    padding-left: 5px;
  }

  .headerContainer {
    display: flex;
    flex-direction: row;
    align-items: center;

    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '1200px'}) {
      flex-direction: column;
      align-items: flex-start;
      gap: 16px;
    }

    .subTitle {
      font-family: ${(props) => props.theme.fonts.sfcompact_text};
      font-size: 12px;
      font-weight: 400;
    }

    @media (max-width: 1200px) {
      flex-direction: column;
      align-items: flex-start;
    }
  }

  .ant-space-gap-col-large {
    column-gap: 20px;
    row-gap: 20px;

    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      column-gap: 16px;
      row-gap: 16px;
    }
  }

  .surveyContent {
    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      line-height: 15px;
    }
  }

  .peer {
    display: none;
  }

  @media (max-width: ${(props) =>
      props.theme.devices.isTablet ? '0px' : '845px'}) {
    .hidden {
      display: none;
    }

    .peer-has-checked:is(:where(.peer):has(:checked) ~ *) {
      display: block;
    }

    .not-peer-has-checked:not(:is(:where(.peer):has(:checked) ~ *)) {
      opacity: 0;
    }

    .transition-all {
      transition-property: all;
    }
  }
`;

export default MediaContainer;
